import { EditShop } from '../../shop-landing-page/shared/models/edit-shop.model';

export class FetchShopInfo {
    static readonly type = '[ShopInfo] fetchShopInfo';
    constructor(public payload: string) { }
}

export class UpdateShopInfo {
    static readonly type = '[ShopInfo] UpdateShopInfo';
    constructor(public payload: EditShop) { }
}

export class CheckAvailabilityOfShopUid {
    static readonly type = '[ShopInfo] CheckAvailabilityOfShopUid';
    constructor(public payload: { shopUid: string } = null) { }
}

export class ResetIsShopUidAvailableFlag {
    static readonly type = '[ShopInfo] ResetIsShopUidAvailableFlag';
    constructor(public payload: any = null) { }
}

export class ResetUpdatedShopUid {
    static readonly type = '[ShopInfo] ResetUpdatedShopUid';
    constructor(public payload: any = null) { }
}

export class UploadShopProfileImage {
    static readonly type = '[ShopInfo] UploadShopProfileImage';
    constructor(public payload: { shopId: string; file: any } = null) { }
}


